import { Injectable } from "@angular/core";

import { Chart } from "highcharts";
import { Observable, ReplaySubject } from "rxjs";

@Injectable({ providedIn: "root" })
export class DffHighchartsLoadingObserver {
    private readonly subject = new ReplaySubject<DffHighchartsLoadingObserverValue>();

    public get valueChanges(): Observable<DffHighchartsLoadingObserverValue> {
        return this.subject.asObservable();
    }

    constructor() {
        const proto = Chart.prototype;
        const origShowLoading = proto.showLoading;
        const origHideLoading = proto.hideLoading;
        const subject = this.subject;
        proto.showLoading = function(this: any, str?: string): void {
            subject.next({ chart: this, loading: true });
            origShowLoading.call(this, str);
        };
        proto.hideLoading = function(this: any): void {
            subject.next({ chart: this, loading: false });
            origHideLoading.call(this);
        };
    }
}

export interface DffHighchartsLoadingObserverValue {
    chart: Highcharts.Chart;
    loading: boolean;
}
